import styled from 'styled-components'
import theme from '../../../common/theme'

export const Wrapper = styled.div`
  margin-top: 120px;
  text-align: center;
  padding: 0px 15px;
`

export const BlueBox = styled.div`
  background: ${theme.color.blue};
  height: 300px;
  width: 1200px;
  z-index: 0;
`

export const WrapRow = styled.div`
  margin-bottom: 98px;
  margin-top: 120px;
  @media (max-width: 768px) {
    margin-top: 0px;
  }
`

export const Image = styled.img``

export const Name = styled.p`
  margin-top: 63px;
  font-size: 2.6rem;
  color: ${theme.color.blue};
  line-height: 30px;
  font-family: 'HumstSlab712BTWXX';
  @media (max-width: 768px) {
    margin-top: 26px;
  }
`
